import { useEffect, useState } from "react";
import Logo from "./Logo";
import { navLinks, professional } from "@/config/professional";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
          scrolled
            ? "border-b border-background-200/70 bg-background-50/85 backdrop-blur-md"
            : "border-b border-transparent bg-transparent"
        }`}
      >
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 md:px-6 lg:px-8">
          <Logo variant={scrolled ? "dark" : "light"} />

          <nav className="hidden items-center gap-8 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`group relative whitespace-nowrap text-sm font-medium transition-colors duration-300 ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary-500 transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={professional.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden whitespace-nowrap rounded-full bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors duration-300 hover:bg-primary-700 md:inline-flex"
            >
              Agendar avaliação
            </a>

            <button
              type="button"
              onClick={() => setOpen(true)}
              aria-label="Abrir menu"
              className={`flex h-11 w-11 items-center justify-center rounded-full border transition-colors duration-300 lg:hidden ${
                scrolled
                  ? "border-background-300 text-foreground-800"
                  : "border-background-50/30 text-background-50"
              }`}
            >
              <i className="ri-menu-line text-xl" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu overlay */}
      <div
        className={`fixed inset-0 z-[60] flex flex-col bg-background-50 transition-opacity duration-300 lg:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <div className="flex h-20 items-center justify-between px-4 md:px-6">
          <Logo variant="dark" />
          <button
            type="button"
            onClick={close}
            aria-label="Fechar menu"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-background-300 text-foreground-800"
          >
            <i className="ri-close-line text-xl" aria-hidden="true"></i>
          </button>
        </div>

        <nav className="flex flex-1 flex-col justify-center gap-2 px-6">
          {navLinks.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              onClick={close}
              className="border-b border-background-200/70 py-4 font-heading text-3xl font-medium text-foreground-900 transition-colors hover:text-primary-600"
              style={{
                transitionDelay: `${i * 40}ms`,
              }}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="px-6 pb-10">
          <a
            href={professional.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-primary-600 px-6 py-4 text-base font-semibold text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
            Agendar avaliação
          </a>
        </div>
      </div>
    </>
  );
}